import React, { Component, Fragment } from 'react';

// import DesktopRegister from './DesktopRegister/DesktopRegister';
import calendar from '../../assets/icons/calendar.svg';
import setting from '../../assets/icons/setting.svg';
import mobile from '../../assets/icons/mobile.svg';
import password from '../../assets/icons/password.svg';
import email from '../../assets/icons/email.svg';
import user from '../../assets/icons/user.svg';

import telegram from '../../assets/icons/telegram.svg';
import instagram from '../../assets/icons/insta.svg';
import twitter from '../../assets/icons/twitter.svg';

import Desktop from './Desktop/Desktop';
import MobileSetting from './MobileSetting/MobileSetting';

export default class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: [
        { name: 'phonenumber', label: 'شماره تلفن', value: null, icon: mobile, placeholder: '9123456789', modal: 'openNumber', type: "number" },
        { name: 'email', label: 'ایمیل', value: null, icon: email, placeholder: 'calendar@gmail.com', modal: 'openEmail', type: "email" },
        { name: 'username', label: 'نام کاربری', value: null, icon: user, placeholder: 'amir', modal: 'openUsername', type: "text" },
        { name: 'password', label: 'رمز عبور', value: null, icon: password, placeholder: '********', modal: 'openPassword', type: "password" },
      ],
      switchs: [
        { title: 'مطلع سازی به وسیله نوتیفیکیشن', name: 'notification' },
        { title: 'پوسته تاریک', name: 'dark' },
      ],
      social: [
        { name: 'instagram', icon: telegram, links: '/' },
        { name: 'telegram', icon: instagram, links: '/' },
        { name: 'twitter', icon: twitter, links: '/' },
      ],
      phonenumber: "",
      email: "",
      username: "",
      password: "",
      password2: "",
      notif: false,
      dark: false,
      openNumber: false,
      openEmail: false,
      openUsername: false,
      openPassword: false,
      validEmail: false,
      validUsername: false,
      validPhonenumber: false,
      validPassword: false,
    }
  }

  openModal = (val) => {
    this.setState({
      [val]: true,
    })
  }


  closeModal = (val) => {
    this.setState({
      [val]: false,
    })
  }

  changeValue = (name, val, type) => {
    if (type === 'text') {
      this.setState({
        [name]: val,
        validUsername: val.match("^[a-zA-Z0-9]{8,38}$")
      })
    }
    else if (type === 'number') {
      this.setState({
        [name]: val,
        validPhonenumber: val.match('^(\\+98|0)?9\\d{9}$'),
      })
    }
    else if (type === 'email') {
      this.setState({
        [name]: val,
        validEmail: val.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
      })
    }
    else if (type === 'password') {
      this.setState({
        [name]: val,
        validPassword: (val.match("^(?=.{8,})") && this.state.password === val) || (val.match("^(?=.{8,})") && this.state.password2 === val),
      })
    }
  }

  setNotif = () => {
    this.setState({
      notif: !this.state.notif,
    })
  }

  setDark = () => {
    this.setState({
      dark: !this.state.dark,
    })
  }

  submitEmail = () => {

  }

  render() {
    const { setOpenSetting } = this.props;
    let setting;
    if (window.innerWidth > 900) {
      setting = <Desktop
        settings={this.state.settings}
        switchs={this.state.switchs}
        social={this.state.social}
        phonenumber={this.state.phonenumber}
        email={this.state.email}
        username={this.state.username}
        password={this.state.password}
        password2={this.state.password2}
        notif={this.state.notif}
        dark={this.state.dark}
        openPassword={this.state.openPassword}
        openUsername={this.state.openUsername}
        openEmail={this.state.openEmail}
        openNumber={this.state.openNumber}
        validEmail={this.state.validEmail}
        validPassword={this.state.validPassword}
        validUsername={this.state.validUsername}
        validPhonenumber={this.state.validPhonenumber}
        openModal={this.openModal}
        closeModal={this.closeModal}
        changeValue={this.changeValue}
        setNotif={this.setNotif}
        setDark={this.setDark}
        setOpenSetting={setOpenSetting}
      />;
    }
    else if (window.innerWidth < 900) {
      setting = <MobileSetting
        settings={this.state.settings}
        switchs={this.state.switchs}
        social={this.state.social}
        phonenumber={this.state.phonenumber}
        email={this.state.email}
        username={this.state.username}
        password={this.state.password}
        password2={this.state.password2}
        notif={this.state.notif}
        dark={this.state.dark}
        openPassword={this.state.openPassword}
        openUsername={this.state.openUsername}
        openEmail={this.state.openEmail}
        openNumber={this.state.openNumber}
        validEmail={this.state.validEmail}
        validPassword={this.state.validPassword}
        validUsername={this.state.validUsername}
        validPhonenumber={this.state.validPhonenumber}
        openModal={this.openModal}
        closeModal={this.closeModal}
        changeValue={this.changeValue}
        setNotif={this.setNotif}
        setDark={this.setDark}
      />;
    }
    return (
      <Fragment>
        { setting}
      </Fragment>
    );
  }
}

